<template>
  <cost-reporter-beta :instance="instance" :token="token" :costReportQueryServer="costReportQueryServer" @failed="onFailed" @setModified="setModified" @clearModified="clearModified" />
</template>

<script>
  import '@sigmacloud/sigma-vue-costreporting'
  // The web component is built with `--target lib` + defineCustomElement({ shadowRoot: false })
  // (light DOM), so its styles are EXTRACTED into dist/cost-reporter-beta.css and are no longer
  // injected the way the old Vue 2 shadow-DOM (`--target wc`) build did — the component rendered
  // with no CSS at all. We can't import that file directly: it bundles a full Bootstrap (reboot on
  // *, body, a, button, input, grid, utilities) that leaks into and overrides the element-plus host
  // (main.js only loads bootstrap-vue-next.css, not Bootstrap core). Instead we import a copy scoped
  // to the <cost-reporter-beta> element, generated by build/scope-costreporter-css.js (postinstall).
  // This bundle also contains vue-multiselect's styles, so no separate multiselect import is needed.
  import '@/assets/styles/cost-reporter-beta.scoped.css'
  export default {
    data () {
      return {
        instance: this.$store.getters.getActiveInstance.url,
        token: this.$store.getters.getActiveInstance.token,
        // When the instance's /sigmaquery.json is empty, getSigmaQueryUrl is null and the cost-report web
        // component renders blank. Fall back to the default sigma-query host, same as Reports.js /
        // SigmaQueryLoader.js, so the report still loads.
        costReportQueryServer: this.$store.getters.getSigmaQueryUrl || 'https://sigma-query.pa.revolutiones.com',
        isModified: false
      }
    },
    methods: {
      onFailed: event => {
        alert('there was an error, please refresh')
      },
      setModified () {
        this.isModified = true
      },
      clearModified () {
        this.isModified = false
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.isModified && !this.$store.getters.getRouteLeaveConfirmation) {
        return this.$store.dispatch('setDestinationRoute', to)
        .then(() => this.$store.dispatch('changeModalVisibility', { entityType: 'changeLossModal', visible: true }))
        .catch(e => console.log(e))
      } else {
        next()
      }
    }
  }
</script>

<style>
  @import 'ag-grid-community/styles/ag-grid.css';
  @import 'ag-grid-community/styles/ag-theme-balham.css';
  @font-face {
    font-family: 'Icons';
    src: url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/fonts/open-iconic.eot');
    src: url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/fonts/open-iconic.eot?#iconic-sm') format('embedded-opentype'), url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/fonts/open-iconic.woff') format('woff'), url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/fonts/open-iconic.ttf') format('truetype'), url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/img/open-iconic.svg#iconic-sm') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  cost-reporter-beta {
    display: block;
    width: 100%;
    background: #ffffff;
    font-family: "Helvetica", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
  }
  /* The web component now renders in light DOM, so without its own shadow-encapsulated styles the
     bootstrap selects collapse and clip their text. Restore bootstrap's natural control sizing. */
  cost-reporter-beta .form-select,
  cost-reporter-beta .form-control {
    height: auto;
    min-height: calc(1.5em + 0.75rem + 2px);
    line-height: 1.5;
  }
</style>
